export default {
  subdomain: 'setram',
  sso: {
    protocol: 'openIDConnect',
    login: 'https://login.microsoftonline.com/73917c59-cf86-46dc-90b3-a3871ab7ee62/oauth2/v2.0/authorize?client_id=eb572ea8-6243-42a7-af85-8a88db2e8adc&response_type=code&scope=openid%20email%20profile&redirect_uri=https%3A%2F%2Fsetram.bubbleplan.net',
    response_type: 'code',
  },
  hideManageAccount: true,
};
